import React from 'react'
import { Button, Select } from 'antd'

import { AppContext } from '../../../AppContext'

import LockBoxCreateModal from '../LockBoxSection/CreateModal'
import InternalKeyCreateModal from '../InternalKeysSection/CreateModal'
import { generateCityFilterOptionsByUserAssignedCity } from '../../../utils/helper'

import LockBoxFields from './LockBoxFields'
import InternalKeysFields from './InternalKeysFields'
import KeyNestFields from './KeyNestFields'

export const labelClassNames = `text-sm text-buttonTheme font-medium 
flex items-center gap-x-1 mb-1 mr-5 md:mr-0`

function KeysPageTopBar (props) {
  const {
    city,
    setCity,
    type,
    setType,
    lockBoxFilters,
    setLockBoxFilters,
    internalKeysFilters,
    setInternalKeysFilters,
    setKeyNestFilters,
    triggerLockBoxCollectionRefetch,
    triggerInternalKeysCollectionRefetch,
    totalLoading,
    totalCount
  } = props

  const profile = React.useContext(AppContext).profile || {}
  const canCreateLockBox = profile?.isAdmin || profile?.createLockBox
  const canReadLockBox = profile?.isAdmin || profile?.readLockBox
  const canReadInternalKeys = profile?.isAdmin || profile?.readInternalKey
  const canCreateInternalKey = profile?.isAdmin || profile?.createInternalKey
  const canReadKeys = profile?.isAdmin || profile?.readKeys

  const [lockBoxSearchValue, setLockBoxSearchValue] = React.useState('')
  const [internalKeySearchValue, setInternalKeySearchValue] = React.useState('')
  const [keyNestSearchValue, setKeyNestSearchValue] = React.useState('')
  const [keyNestTypeValue, setKeyNestTypeValue] = React.useState('')

  const [createLockBoxModalOpen, setCreateLockBoxModalOpen] = React.useState(false)
  const [createInternalKeyModalOpen, setCreateInternalKeyModalOpen] = React.useState(false)

  const cityFilterOptions = generateCityFilterOptionsByUserAssignedCity(profile)

  const typeSelectOptions = [
    canReadLockBox && {
      label: 'LockBox',
      value: 'lockBox'
    },
    canReadInternalKeys && {
      label: 'Internal Keys',
      value: 'internalKeys'
    },
    canReadKeys && {
      label: 'KeyNest',
      value: 'keyNest'
    }
  ].filter(Boolean)

  return (
    <div>
      <div className="flex items-end gap-3 flex-wrap">
        <div className="text-themeGrey text-xl font-bold mr-auto">
          Keys{' '}
          {!!totalCount && !totalLoading && `(${totalCount})`}
        </div>

        {canCreateLockBox && type === 'lockBox' && (
          <Button
            className="bg-buttonTheme hover:!bg-buttonHoverTheme shadow-none"
            onClick={() => setCreateLockBoxModalOpen(true)}
            type="primary"
          >
            Add new lockBox
          </Button>
        )}

        {canCreateInternalKey && type === 'internalKeys' && (
          <Button
            className="bg-buttonTheme hover:!bg-buttonHoverTheme shadow-none"
            onClick={() => setCreateInternalKeyModalOpen(true)}
            type="primary"
          >
            Add new internal key
          </Button>
        )}

        <Select
          className="w-[145px]"
          options={typeSelectOptions}
          onChange={nextType => setType(nextType)}
          value={type}
        />
      </div>

      <div className="flex items-end gap-3 flex-wrap pt-2">
        {canReadLockBox && type === 'lockBox' && (
          <LockBoxFields
            filters={lockBoxFilters}
            setFilters={setLockBoxFilters}
            searchValue={lockBoxSearchValue}
            setSearchValue={setLockBoxSearchValue}
          />
        )}

        {type === 'internalKeys' && (
          <InternalKeysFields
            filters={internalKeysFilters}
            setFilters={setInternalKeysFilters}
            searchValue={internalKeySearchValue}
            setSearchValue={setInternalKeySearchValue}
          />
        )}

        {canReadKeys && type === 'keyNest' && (
          <KeyNestFields
            setFilters={setKeyNestFilters}
            searchValue={keyNestSearchValue}
            setSearchValue={setKeyNestSearchValue}
            keyTypeValue={keyNestTypeValue}
            setKeyTypeValue={setKeyNestTypeValue}
          />
        )}

        {(canReadKeys || canReadLockBox) && (
          <div className="w-[200px]">
            <div className={labelClassNames}>
              City
            </div>

            <Select
              className="w-full"
              placeholder="Select city"
              options={cityFilterOptions}
              disabled={!cityFilterOptions.length}
              onChange={value => setCity(value)}
              value={city}
              allowClear
            />
          </div>
        )}
      </div>

      {canCreateLockBox && (
        <LockBoxCreateModal
          open={createLockBoxModalOpen}
          onClose={() => setCreateLockBoxModalOpen(false)}
          triggerLockBoxCollectionRefetch={triggerLockBoxCollectionRefetch}
        />
      )}

      {canCreateInternalKey && (
        <InternalKeyCreateModal
          open={createInternalKeyModalOpen}
          onClose={() => setCreateInternalKeyModalOpen(false)}
          triggerCollectionRefetch={triggerInternalKeysCollectionRefetch}
        />
      )}
    </div>
  )
}

export default KeysPageTopBar
